"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyMetadata = getKeyMetadata;
function getKeyMetadata(encryptedKey) {
    var id = encryptedKey.id;
    return {
        id: id,
    };
}
